module.exports = __webpack_public_path__ + "static/media/baseball-icon.a72cfd24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baseball-icon.svg
// module id = 43
// module chunks = 0